import { Directive, Input } from '@angular/core';
import { Validator, NG_VALIDATORS,  FormControl, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[customZero]',
  providers: [{provide: NG_VALIDATORS, useExisting: CustomNonNegativeDirective, multi: true}]
})
export class CustomNonNegativeDirective implements Validator {

  @Input('customZero')  min: number;
  constructor() { }

  validate(c: AbstractControl): {[key: string]: any} | null {
    const retValue = c.value;
    return ( retValue && retValue <= this.min ) ? {'customZero': true} : null;
   }
}

